import Head from "view/components/Head";
import { useParams } from "react-router-dom";

type PageHeadingProps = {
  programName?: string;
};

const PageHeading = ({ programName }: PageHeadingProps) => {
  const { programId } = useParams<{
    programId: string;
  }>();
  return (
    <div className="flex flex-col justify-start items-start flex-grow py-0.5">
      <Head title={`${programId ? programName : "Reports"}`} />
      <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
        <p className="break-all w-full text-[28px] font-bold text-left text-textMid dark:text-textMain">
          {`${programId ? programName : "Reports"}`}
        </p>
      </div>
    </div>
  );
};

export { PageHeading };
